import React from 'react';
import { Button } from '@mui/material';
import { DOWNLOAD_CAPTION } from '../constants/TranslationConstants';

interface DownloadButtonProps {
  fileName: string;
  onDownload: () => void;
}

const DownloadButton = ({ fileName, onDownload }: DownloadButtonProps) => {
  return (
    <Button
      variant="contained"
      onClick={onDownload}
      size="small"
      sx={{
        fontSize: "10px",
        background: "#006684",
        height: "30px",
        color: "#FFFFFF",
        cursor: "pointer",
        textTransform: "capitalize",
        fontWeight: "600",
        '&:hover': {
          backgroundColor: "#005a70",
        }
      }}
    >
      {DOWNLOAD_CAPTION}
    </Button>
  );
};

export default DownloadButton;